import { InjectionToken } from '@angular/core';

/**
 * The URL for the feature flag API
 */
export const FEATURE_FLAG_URL = new InjectionToken<string>('FEATURE_FLAG_URL');
